import * as React from 'react'
import styled from 'styled-components'
import { useHydrateAtoms } from 'jotai/utils'
import * as plume from '@ulule/owl-kit-components/next'

import { Breadcrumbs } from './Breadcrumbs'
import { Hero } from './Hero'
import { Pagination } from './Pagination'
import { Results } from './Results'
import { Seo } from './Seo'
import { Sort } from './Sort'
import * as service from '@boutique/services'
import { BasePageProps } from '@boutique/layout'

export type GiftIdeasProps = BasePageProps & {
  productCache: service.search.giftIdea.Cache
}

export function GiftIdeas({ productCache }: GiftIdeasProps) {
  useHydrateAtoms([[service.search.giftIdea.PRODUCT_CACHE, productCache]])

  return (
    <Container>
      <Seo />
      <Breadcrumbs />
      <Hero />
      <Sort />
      <Results />
      <Pagination />
    </Container>
  )
}

const Container = styled(plume.Container)`
  ${plume.Breadcrumbs} {
    margin-bottom: 47px;
  }
`
